import axios from 'axios';
import {
  CUSTOMER_SERVICE_INITIATE_IMPORT_TEMPLATE,
  CUSTOMER_SERVICE_RETRIEVE_IMPORT_TEMPLATE,
  CUSTOMER_SERVICE_INITIATE_EXPORT_TEMPLATE,
  CUSTOMER_SERVICE_RETRIEVE_EXPORT_TEMPLATE,
} from '../constants';
import {
  CUSTOMERS,
  CUSTOMER_DETAIL,
  REDEMPTION_HISTORIES,
  POINT_ACTIVITIES,
  CUSTOMER_PAYMENTS,
} from './constants';

function commonReject(error) {
  if (error.response) {
    let eobj;
    const { data } = error.response;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
    return Promise.reject(eobj);
  }
  return Promise.reject(new Error(error.message));
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/customers_controller.rb#L5
 * @param params
 * @return {Axios.IPromise<U>}
 */
export function getCustomers(params) {
  return axios
    .get(CUSTOMERS, { params, withCredentials: false })
    .catch(commonReject);
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/customers_controller.rb#L35
 * @param params
 * @return {Axios.IPromise<U>}
 */
export function getCustomerDetail(customerId, params) {
  return axios.get(CUSTOMER_DETAIL(customerId), { params }).catch(commonReject);
}

export function getPaymentHistories(customerId, params) {
  return axios
    .get(CUSTOMER_PAYMENTS(customerId), { params })
    .catch(commonReject);
}

export function getRedemptionHistories(customerId, params) {
  return axios
    .get(REDEMPTION_HISTORIES(customerId), { params })
    .catch(commonReject);
}

export function getPointActivities(customerId, params) {
  return axios
    .get(POINT_ACTIVITIES(customerId), { params })
    .catch(commonReject);
}

export function customerServiceInitiateImportTemplate() {
  return axios
    .get(CUSTOMER_SERVICE_INITIATE_IMPORT_TEMPLATE(), { withCredentials: true })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}

export function customerServiceRetrieveImportTemplate(fileId) {
  return axios
    .get(CUSTOMER_SERVICE_RETRIEVE_IMPORT_TEMPLATE(fileId), {
      withCredentials: true,
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}

export function customerServiceInitiateExportTemplate(params) {
  return axios
    .get(CUSTOMER_SERVICE_INITIATE_EXPORT_TEMPLATE(), { params })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}

export function customerServiceRetrieveExportTemplate(fileId) {
  return axios
    .get(CUSTOMER_SERVICE_RETRIEVE_EXPORT_TEMPLATE(fileId), {
      withCredentials: true,
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}
